<template>
	<!-- Off-screen host: print(model) renders PosReceiptPreview into a hidden
	     iframe sized for 80 mm paper and calls print() on it (spec §7 PosBills
	     "reprint", §6.6 print CSS). -->
	<div class="pos-receipt-print-host" aria-hidden="true"></div>
</template>

<script>
import Vue from "vue";
import PosReceiptPreview from "./PosReceiptPreview.vue";
import { POS_RECEIPT_CSS, POS_PRINT_PAGE_CSS, posPrintPageSizeCss } from "@/utils/posReceiptCss";

export default {
	name: "PosReceiptPrint",
	methods: {
		// Resolves once the print dialog has closed (afterprint) or after 60 s.
		print(model) {
			return new Promise((resolve) => {
				const Ctor = Vue.extend(PosReceiptPreview);
				const vm = new Ctor({ propsData: { model, screen: false } }).$mount();
				const iframe = document.createElement("iframe");
				iframe.setAttribute("aria-hidden", "true");
				// 80 mm wide so the receipt lays out (and measures) at paper width.
				iframe.style.cssText = "position:fixed;left:-10000px;top:0;width:80mm;height:10px;border:0;visibility:hidden";
				document.body.appendChild(iframe);
				const doc = iframe.contentWindow.document;
				doc.open();
				doc.write(`<!doctype html><html><head><meta charset="utf-8"><title>${(model && model.bill_no) || "receipt"}</title><style>${POS_RECEIPT_CSS}${POS_PRINT_PAGE_CSS}</style></head><body>${vm.$el.outerHTML}</body></html>`);
				doc.close();
				vm.$destroy();
				let done = false;
				const finish = () => {
					if (done) return;
					done = true;
					setTimeout(() => iframe.remove(), 100);
					resolve({ ok: true, method: "web" });
				};
				const go = () => {
					const imgs = Array.from(doc.images || []);
					Promise.all(imgs.map((im) => (im.decode ? im.decode().catch(() => null) : null))).then(() => {
						// Size the page to the receipt: 80 mm × measured height (mm).
						const el = doc.querySelector(".pos-receipt");
						const h = el ? el.getBoundingClientRect().height : 0;
						const page = doc.createElement("style");
						page.id = "pos-page-size";
						page.textContent = posPrintPageSizeCss(h);
						doc.head.appendChild(page);
						iframe.contentWindow.addEventListener("afterprint", finish);
						setTimeout(finish, 60000);
						iframe.contentWindow.focus();
						iframe.contentWindow.print();
					});
				};
				if (doc.readyState === "complete") go();
				else iframe.onload = go;
			});
		}
	}
};
</script>
